import type * as Types from '../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUnitsMatrixParametersQueryVariables = Types.Exact<{
  unitIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;


export type GetUnitsMatrixParametersQuery = { __typename?: 'Query', units?: { __typename?: 'UnitCollectionSegment', items?: Array<{ __typename?: 'Unit', id: string, matrixType?: Types.MatrixType | null, inertiaParameters?: { __typename?: 'InertiaParameters', taGen: number, taZus: number, taGes: number } | null, matrixParameters?: { __typename?: 'MatrixParameters', zwValues: Array<number>, taMin?: { __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> } | null, taMax?: { __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> } | null, taRange?: Array<{ __typename?: 'TimePowerParameters', pMinDyn: number, pMaxDyn: number, pGrenzNegMin: number, pGrenzNegMax: number, pGrenzPosMin: number, pGrenzPosMax: number, taValue: number, effectiveImpedances: Array<boolean> }> | null } | null }> | null } | null };


        export type ExecGetUnitsMatrixParametersOptions = Omit<
        Apollo.QueryOptions<
        GetUnitsMatrixParametersQueryVariables, GetUnitsMatrixParametersQuery
        >,
        "query"
      >;
    export const execGetUnitsMatrixParametersQuery = (options: ExecGetUnitsMatrixParametersOptions) =>
    client.query< GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>({
      ...options,
      query: GetUnitsMatrixParametersDocument,
    });
    

export const GetUnitsMatrixParametersDocument = gql`
    query getUnitsMatrixParameters($unitIds: [UUID!]!) {
  units(unitIds: $unitIds) {
    items {
      id
      matrixType
      inertiaParameters {
        taGen
        taZus
        taGes
      }
      matrixParameters {
        taMin {
          pMinDyn
          pMaxDyn
          pGrenzNegMin
          pGrenzNegMax
          pGrenzPosMin
          pGrenzPosMax
          taValue
          effectiveImpedances
        }
        taMax {
          pMinDyn
          pMaxDyn
          pGrenzNegMin
          pGrenzNegMax
          pGrenzPosMin
          pGrenzPosMax
          taValue
          effectiveImpedances
        }
        taRange {
          pMinDyn
          pMaxDyn
          pGrenzNegMin
          pGrenzNegMax
          pGrenzPosMin
          pGrenzPosMax
          taValue
          effectiveImpedances
        }
        zwValues
      }
    }
  }
}
    `;

/**
 * __useGetUnitsMatrixParametersQuery__
 *
 * To run a query within a React component, call `useGetUnitsMatrixParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsMatrixParametersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsMatrixParametersQuery({
 *   variables: {
 *      unitIds: // value for 'unitIds'
 *   },
 * });
 */
export function useGetUnitsMatrixParametersQuery(baseOptions: Apollo.QueryHookOptions<GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>(GetUnitsMatrixParametersDocument, options);
      }
export function useGetUnitsMatrixParametersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>(GetUnitsMatrixParametersDocument, options);
        }
export type GetUnitsMatrixParametersQueryHookResult = ReturnType<typeof useGetUnitsMatrixParametersQuery>;
export type GetUnitsMatrixParametersLazyQueryHookResult = ReturnType<typeof useGetUnitsMatrixParametersLazyQuery>;
export type GetUnitsMatrixParametersQueryResult = Apollo.QueryResult<GetUnitsMatrixParametersQuery, GetUnitsMatrixParametersQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;